import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
/**
 * @function retrieve
 * @since 1.0.0
 * @hidden
 */
function retrieve(uri, options) {
    if (options.useUpload) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.onload = () => {
                const opts = {
                    url: xhr.responseURL,
                    status: xhr.status,
                    statusText: xhr.statusText,
                    headers: parse(xhr.getAllResponseHeaders() || '')
                };
                const body = 'response' in xhr ? xhr.response : xhr.responseText;
                resolve(new Response(body, opts));
            };
            xhr.onerror = () => {
                reject(new TypeError('Network request failed'));
            };
            xhr.ontimeout = () => {
                reject(new TypeError('Network request failed'));
            };
            xhr.open(options.method, uri, true);
            Object.keys(options.headers).forEach((key) => {
                xhr.setRequestHeader(key, options.headers[key]);
            });
            if (xhr.upload) {
                xhr.upload.onprogress = function (e) {
                    if (options.onProgress) {
                        options.onProgress(e.loaded / e.total, e.loaded);
                    }
                };
            }
            if (options.onStart) {
                options.onStart(() => {
                    xhr.abort();
                });
            }
            xhr.send(options.body);
        });
    }
    return fetch(uri, options);
}
/**
 * @function parse
 * @since 1.0.0
 * @hidden
 */
function parse(string) {
    const headers = new Headers();
    for (const line of split(string)) {
        const entry = line.split(':');
        const key = entry[0];
        const val = entry[1];
        if (key && val) {
            headers.append(key, val);
        }
    }
    return headers;
}
/**
 * @function split
 * @since 1.0.0
 * @hidden
 */
function split(string) {
    return string.replace(/\r?\n[\t ]+/g, ' ').split(/\r?\n/);
}
/**
 * Manages http connections.
 * @const httpLink
 * @since 1.0.0
 */
export function httpLink(uri) {
    return createUploadLink({
        uri,
        credentials: 'include',
        fetch: retrieve
    });
}
